import SubscriptionPlan from "types/enums/SubscriptionPlan"

export const subscriptionPlanBundlesContractorsUniversity = (plan: SubscriptionPlan | undefined): boolean =>
  plan === SubscriptionPlan.E_PLUS || plan === SubscriptionPlan.GROW_MARCH_2026
